import React from "react";

import { Redirect, Route, Switch } from "react-router-dom";

import Alerts from "./Alerts";
import Error from "./Error";

export default function Page({ alerts, path, routes }) {
  const defaultRoute =
    routes &&
    routes.length &&
    routes.find((route) => route.path && !route.path.includes(":"));

  return (
    <React.Fragment>
      <Alerts items={alerts} />
      <Switch>
        {defaultRoute && <Redirect exact from={path} to={defaultRoute.path} />}
        {routes && routes.map((route, key) => <Route key={key} {...route} />)}
        <Route exact path={path} />
        <Route component={Error} />
      </Switch>
    </React.Fragment>
  );
}

Page.Error = Error;
